<template>
  <div
    class="hcl-block card"
    v-bind="attributesMeta(props.definition?.meta)"
  >
    <div
      class="hcl-block-header card-header"
      v-if="props.definition?.header?.length > 0"
    >
      <component
        v-for="header in props.definition.header"
        :is="componentMeta(header.meta)"
        :key="header.meta.id"
        :definition="header"
        v-on:hcl-button-clicked="onButtonClicked"
      >
      </component>
    </div>
    <div
      class="hcl-block-content card-body"
      v-if="props.definition?.content?.length > 0"
    >
      <component
        v-for="content in props.definition.content"
        :is="componentMeta(content.meta)"
        :key="content.meta.id"
        :definition="content"
        v-on:hcl-button-clicked="onButtonClicked"
      >
      </component>
    </div>
    <div
      class="hcl-block-footer card-footer"
      v-if="props.definition?.footer?.length > 0"
    >
      <component
        v-for="footer in props.definition.footer"
        :is="componentMeta(footer.meta)"
        :key="footer.meta.id"
        :definition="footer"
        v-on:hcl-button-clicked="onButtonClicked"
      >
      </component>
    </div>
  </div>
</template>

<script setup lang="ts">
import { provide } from 'vue'

import { useMeta } from '@/composables/meta'

import { DefinitionBlock, EventButtonClicked } from '@/components/types'

import { useStateStore } from '@/stores/state'

interface Props {
  /**
   * Definition as an JS object.
   */
  definition: DefinitionBlock
}

const props = withDefaults(defineProps<Props>(), {
  definition: undefined
})

const { componentMeta, attributesMeta } = useMeta()

provide('blockMetaId', props.definition.meta.id ?? '')

const { getBlockGroupNameValueWithDefault, updateBlockGroupNameValue } = useStateStore()

const onButtonClicked = (event: EventButtonClicked) => {
  if (event.type === 'toggle' && event.id === 'visibility') {
    const state = getBlockGroupNameValueWithDefault(
      props.definition.meta.id,
      'form',
      'visibility',
      true
    )

    updateBlockGroupNameValue(props.definition.meta.id, 'form', 'visibility', !state.value)
  }
}
</script>
